function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Group 6");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Br\xEDet",
  transform: "translate(-238.000000, -2797.000000)"
}, React.createElement("g", {
  id: "Group-6",
  transform: "translate(153.000000, 2784.000000)"
}, React.createElement("g", {
  id: "Group-3"
}, React.createElement("g", {
  id: "A-Human/Standing"
}, React.createElement("g", {
  id: "Head/Front/Afro",
  transform: "translate(82.000000, 0.000000)"
}, React.createElement("path", {
  d: "M61,77.7068588 C72.4289379,77.7068588 76.5854974,64.0240838 83.0786187,56.5153483 C87.7243138,51.143002 95.6530795,52.7449442 98,45.2237762 C103.901542,26.3111237 88.1061086,13 67.5,13 C46.8938914,13 33,24.6742524 30,42.2237762 C27,59.7733 40.3938914,77.7068588 61,77.7068588 Z",
  id: "Hair-Back",
  fill: "#191847"
}), React.createElement("g", {
  id: "Head",
  strokeWidth: 1,
  transform: "translate(54.000000, 31.000000)",
  fill: "#D4A181"
}, React.createElement("path", {
  d: "M8.26227388,34.4901268 C3.65436435,29.0813759 0.535634794,22.4528771 1.05677633,15.0254539 C2.55833022,-6.37502057 32.3485306,-1.66718886 38.1433414,9.13393292 C43.9381521,19.9350547 43.249578,47.3329958 35.7603014,49.2634576 C32.7735882,50.033323 26.4110012,48.1474609 19.935372,44.244306 L24,73 L0,73 L8.26227388,34.4901268 Z"
})), React.createElement("path", {
  d: "M72.379769,51.7233675 C71.5077737,51.2620302 70.5086201,51 69.4466684,51 C66.0464589,51 63.2900445,53.6862915 63.2900445,57 C63.2900445,58.3524891 63.749225,59.6004592 64.5239446,60.6039231 C63.0651901,63.0083834 62.0695832,65.5346814 61.7432388,68.1317726 C56.6870351,68.1317726 38.2335803,49 56.6167901,31 C75,13 101.566014,38.6959598 93.5831606,40.1945268 C88.9934286,41.0561261 79.7498479,45.4379083 72.3797716,51.7233656 Z",
  id: "Hair",
  fill: "#191847"
})), React.createElement("g", {
  id: "Bottom/Standing/Shorts",
  transform: "translate(0.000000, 187.000000)"
}, React.createElement("polygon", {
  id: "Leg",
  fill: "#997659",
  points: "128 9.9475983e-14 165.630838 123.024171 183.860154 227.648304 198.153197 227.648304 178.890974 9.9475983e-14"
}), React.createElement("path", {
  d: "M114.537727,0 C117.093705,67.5468821 114.085665,102.388787 113.513606,108.525715 C112.941548,114.662643 105.108196,154.454812 86.5636874,229.708469 L101.793992,224.477699 C131.10186,155.458959 141.088936,119.5887 144.450326,110.525715 C147.811717,101.46273 156.739403,64.6208249 171.233385,0 L114.537727,0 Z",
  id: "Leg",
  fill: "#B28B67"
}), React.createElement("g", {
  id: "Accessories/Shoe/Flat-Sneaker",
  transform: "translate(84.000000, 199.000000)",
  fill: "#E4E4E4"
}, React.createElement("path", {
  d: "M2.67813181,25.4019242 C1.55937727,28.3884109 1,30.6229931 1,32.1056708 C1,33.908957 1.3004142,36.5404001 1.90124261,40 C3.99318117,40 22.7937852,40 58.3030548,40 C59.768738,35.1545073 58.9226607,32.5385816 55.7648228,32.1522232 C52.606985,31.7658647 49.9837155,31.4170139 47.8950143,31.1056708 L21.6799926,19.4188835 C21.1755635,19.1940064 20.584344,19.4206282 20.359467,19.9250573 C20.35562,19.9336867 20.3518954,19.9423702 20.3482945,19.9511052 L18.6632131,24.038695 C15.7398812,25.4026522 13.3643706,26.0846307 11.5366811,26.0846307 C10.0517269,26.0846307 8.00099246,25.4849054 5.38447792,24.2854549 L5.38448339,24.285443 C4.38038273,23.8251478 3.19325534,24.2659892 2.73296014,25.2700899 C2.71312074,25.3133681 2.69483298,25.3573409 2.67813181,25.4019242 Z",
  id: "shoe"
})), React.createElement("g", {
  id: "Accessories/Shoe/Flat-Sneaker",
  transform: "translate(178.000000, 199.000000)",
  fill: "#E4E4E4"
}, React.createElement("path", {
  d: "M2.67813181,25.4019242 C1.55937727,28.3884109 1,30.6229931 1,32.1056708 C1,33.908957 1.3004142,36.5404001 1.90124261,40 C3.99318117,40 22.7937852,40 58.3030548,40 C59.768738,35.1545073 58.9226607,32.5385816 55.7648228,32.1522232 C52.606985,31.7658647 49.9837155,31.4170139 47.8950143,31.1056708 L21.6799926,19.4188835 C21.1755635,19.1940064 20.584344,19.4206282 20.359467,19.9250573 C20.35562,19.9336867 20.3518954,19.9423702 20.3482945,19.9511052 L18.6632131,24.038695 C15.7398812,25.4026522 13.3643706,26.0846307 11.5366811,26.0846307 C10.0517269,26.0846307 8.00099246,25.4849054 5.38447792,24.2854549 L5.38448339,24.285443 C4.38038273,23.8251478 3.19325534,24.2659892 2.73296014,25.2700899 C2.71312074,25.3133681 2.69483298,25.3573409 2.67813181,25.4019242 Z",
  id: "shoe"
})), React.createElement("polygon", {
  id: "Bottom",
  fill: "#69A1AC",
  points: "123 0 139 62.6795201 187.870318 62.6795201 180.583554 0"
}), React.createElement("path", {
  d: "M114,-3.55271368e-15 C108.735439,15.7805461 107.735439,36.6737195 111,62.6795201 L160.870318,62.6795201 L174.583554,-3.55271368e-15 L114,-3.55271368e-15 Z",
  id: "Bottom",
  fill: "#89C5CC"
})), React.createElement("g", {
  id: "Body/Pregnant",
  transform: "translate(22.000000, 82.000000)"
}, React.createElement("path", {
  d: "M111.093239,2.28693343 C111.326698,1.52679592 111.563732,0.764490814 111.80423,9.9475983e-14 L112.692183,0.417788314 C112.830751,0.274814904 112.970357,0.135528873 113.111009,-8.52651283e-14 L141.101479,4.32798224 C141.101479,20.0687681 153.625725,34.7964415 161.54868,47.4680378 C173.864991,67.1661596 195.780651,88.999709 181.72922,118.263682 C169.06816,144.632022 136.088855,148.914077 82.7913029,131.10985 C82.7913029,116.907461 94.4646183,102.629645 94.8366189,85.3605479 C95.1907472,68.9211259 98.2646207,19.1125342 111.093239,2.28693343 Z",
  id: "Shirt",
  fill: "#C1DEE2"
}), React.createElement("path", {
  d: "M145.863007,110.787221 C147.734877,101.126929 148.949202,94.6776016 149.505985,91.4392393 C164.417959,108.29011 173.032716,116.813278 175.350255,117.008742 C179.708836,117.37635 182.929474,113.51125 183.84651,114.597847 C185.362212,119.097853 181.081226,130.362106 172.89821,132 C168.990655,132.782127 162.94394,124.724092 160.45259,121.868948 C159.4727,120.745971 154.609505,117.052062 145.863007,110.787221 L145.863007,110.787221 Z M171.62123,59.2823205 C175.486784,59.2823205 177.563178,60.8804131 179.848781,64.1046411 C182.134384,67.328869 184.297191,82.5350373 180.6276,82.5350373 C176.958008,82.5350373 161.583419,76.656821 161.583419,72.7050102 C161.583419,68.7531993 172.074145,67.079644 172.074145,64.1046411 C172.074145,61.1296381 167.755676,59.2823205 171.62123,59.2823205 Z",
  id: "Skin",
  fill: "#D4A181"
}), React.createElement("path", {
  d: "M138.059083,125.487626 C137.829455,126.309648 137.595361,127.147106 137.356799,128 C93.560817,97.3905148 93.5398055,60.2964284 106.564993,18.7185807 C96.7475495,59.6508736 100.747151,94.1732973 138.059083,125.487626 Z",
  id: "Shade",
  fillOpacity: 0.2,
  fill: "#000000"
})))), React.createElement("g", {
  id: "Head/Front/Short-2",
  transform: "translate(465.000000, 142.000000) scale(-1, 1) translate(-465.000000, -142.000000) translate(397.000000, 90.000000)"
}, React.createElement("g", {
  id: "Head",
  strokeWidth: 1,
  transform: "translate(54.000000, 31.000000)",
  fill: "#D4A181"
}, React.createElement("path", {
  d: "M8.26227388,34.4901268 C3.65436435,29.0813759 0.535634794,22.4528771 1.05677633,15.0254539 C2.55833022,-6.37502057 32.3485306,-1.66718886 38.1433414,9.13393292 C43.9381521,19.9350547 43.249578,47.3329958 35.7603014,49.2634576 C32.7735882,50.033323 26.4110012,48.1474609 19.935372,44.244306 L24,73 L0,73 L8.26227388,34.4901268 Z"
})), React.createElement("path", {
  d: "M60.4181384,70.3075201 C57.4059021,56.9064588 48.8245327,47.7714043 50.1351137,41.781703 C51.0088343,37.7885688 53.3375617,35.3053788 57.1212959,34.3321331 C59.0782074,26.4155009 65.3896485,23.0482486 76.0556193,24.2303763 C92.0545754,26.0035679 101.819448,32.6477587 97.6024819,47.2678779 C93.7260987,47.2678779 89.0464758,45.8659867 82.57553,48.2678779 C80.5223249,49.0299883 79.0538125,51.3933595 78.1699927,55.3579915 L75.2457978,55.3579915 C72.4077436,50.6530572 69.6094038,48.9241222 66.8507787,50.1711866 C64.0921535,51.418251 63.4650732,54.4473753 64.9695377,59.2585597 L63.529076,70.3075201 L60.4181384,70.3075201 Z",
  id: "Hair",
  fill: "#191847"
})), React.createElement("g", {
  id: "Bottom/Sitting/Skinny-Jeans-1",
  transform: "translate(465.000000, 396.500000) scale(-1, 1) translate(-465.000000, -396.500000) translate(315.000000, 277.000000)"
}, React.createElement("g", {
  id: "Objects/Seat/Cube",
  transform: "translate(10.000000, 42.000000)",
  strokeWidth: 1
}, React.createElement("g", {
  id: "Seat",
  transform: "translate(55.000000, 0.000000)"
}, React.createElement("polygon", {
  id: "Seat-Stuff",
  fill: "#C5CFD6",
  points: "27.6226415 0 104.877193 0 115 124 0 124"
}), React.createElement("polygon", {
  id: "Seat-Stuff",
  fillOpacity: 0.1,
  fill: "#000000",
  points: "27.6226415 0 51.3828011 0 65.6037736 124 0 124"
}))), React.createElement("path", {
  d: "M257.953294,20.7561262 C266.190093,15.8101469 280.009488,22.164715 280,29.2384154 C279.971611,50.4029106 260.656682,150.1511 259.648224,156.456711 C258.639766,162.762321 247.83665,164.42787 247.20755,156.477375 C246.206544,143.826795 244.3468,100.033121 246.20755,79.7626522 C246.975628,71.3954284 247.802807,63.4267637 248.617148,56.3175946 C238.481902,74.6206031 222.807229,100.825998 201.593128,134.933778 L190.076573,129.672175 C199.120166,99.8760987 206.535776,78.8408618 212.323403,66.5664641 C222.233227,45.5497154 231.525307,27.551672 235.436043,21.2120072 C241.587634,11.2397104 252.295462,14.7191925 257.953294,20.7561262 Z",
  id: "Skin",
  fill: "#B28B67"
}), React.createElement("path", {
  d: "M208.819223,123.340112 L213.936922,21.8299349 C217.625361,4.27739957 248.84365,12.4235349 248.830812,21.8299349 C248.801666,43.1853748 235.973522,116.956762 235.964839,123.319261 L208.819223,123.340112 Z",
  id: "LegLower",
  fill: "#1F28CF",
  transform: "translate(228.825019, 67.419630) rotate(20.000000) translate(-228.825019, -67.419630) "
}), React.createElement("g", {
  id: "Accessories/Shoe/Flat-Sneaker",
  transform: "translate(215.500000, 133.000000) rotate(30.000000) translate(-215.500000, -133.000000) translate(185.000000, 113.000000)",
  fill: "#E4E4E4"
}, React.createElement("path", {
  d: "M2.67813181,25.4019242 C1.55937727,28.3884109 1,30.6229931 1,32.1056708 C1,33.908957 1.3004142,36.5404001 1.90124261,40 C3.99318117,40 22.7937852,40 58.3030548,40 C59.768738,35.1545073 58.9226607,32.5385816 55.7648228,32.1522232 C52.606985,31.7658647 49.9837155,31.4170139 47.8950143,31.1056708 L21.6799926,19.4188835 C21.1755635,19.1940064 20.584344,19.4206282 20.359467,19.9250573 C20.35562,19.9336867 20.3518954,19.9423702 20.3482945,19.9511052 L18.6632131,24.038695 C15.7398812,25.4026522 13.3643706,26.0846307 11.5366811,26.0846307 C10.0517269,26.0846307 8.00099246,25.4849054 5.38447792,24.2854549 L5.38448339,24.285443 C4.38038273,23.8251478 3.19325534,24.2659892 2.73296014,25.2700899 C2.71312074,25.3133681 2.69483298,25.3573409 2.67813181,25.4019242 Z",
  id: "shoe"
})), React.createElement("g", {
  id: "Accessories/Shoe/Flat-Sneaker",
  transform: "translate(242.000000, 126.000000)",
  fill: "#E4E4E4"
}, React.createElement("path", {
  d: "M2.67813181,25.4019242 C1.55937727,28.3884109 1,30.6229931 1,32.1056708 C1,33.908957 1.3004142,36.5404001 1.90124261,40 C3.99318117,40 22.7937852,40 58.3030548,40 C59.768738,35.1545073 58.9226607,32.5385816 55.7648228,32.1522232 C52.606985,31.7658647 49.9837155,31.4170139 47.8950143,31.1056708 L21.6799926,19.4188835 C21.1755635,19.1940064 20.584344,19.4206282 20.359467,19.9250573 C20.35562,19.9336867 20.3518954,19.9423702 20.3482945,19.9511052 L18.6632131,24.038695 C15.7398812,25.4026522 13.3643706,26.0846307 11.5366811,26.0846307 C10.0517269,26.0846307 8.00099246,25.4849054 5.38447792,24.2854549 L5.38448339,24.285443 C4.38038273,23.8251478 3.19325534,24.2659892 2.73296014,25.2700899 C2.71312074,25.3133681 2.69483298,25.3573409 2.67813181,25.4019242 Z",
  id: "shoe"
})), React.createElement("path", {
  d: "M282.770373,36.4330278 C282.770373,63 270.1536,124.970293 270.145616,130.820112 L243,130.840963 C246.973277,75.5454811 248.382172,47.5998928 247.226683,47.0041979 C245.49345,46.1106556 176.175838,53.9250306 155.386358,53.9250306 C125.407825,53.9250306 113.006307,35.0203971 112,-4.40536496e-13 L171.386358,-4.40536496e-13 C183.477954,1.29386693 246.548825,14.0152568 269.972097,18.3884129 C280,20.2606358 282.770373,29.1145109 282.770373,36.4330278 Z",
  id: "Leg-and-Butt",
  fill: "#2B44FF"
})), React.createElement("g", {
  id: "Body/Jacket",
  transform: "translate(465.000000, 265.500000) scale(-1, 1) translate(-465.000000, -265.500000) translate(337.000000, 172.000000)"
}, React.createElement("path", {
  d: "M194.04441,89.1225115 L222.372314,116.757535 C230.61469,120.273345 237.368143,124.155511 242.632673,128.40403 C243.816587,129.832102 245.10547,132.568362 239.535214,131.343925 C233.964957,130.119488 228.050816,129.082079 227.003896,130.893567 C225.956977,132.705055 229.041811,135.480899 227.106974,137.851671 C225.817082,139.432186 221.479076,134.404878 214.092956,122.769747 L184.635682,105.402467 L194.04441,89.1225115 Z M68.3079281,93.0198914 L89.2053198,93.1020711 C76.3021447,134.755739 69.3363474,156.856914 68.3079281,159.405597 C65.9939846,165.140133 70.8906002,173.873732 72.9845874,178.567103 C66.1645409,181.61887 66.8912241,170.316929 58.2879189,174.319492 C50.4352209,177.972846 44.4616931,184.59248 35.3890352,178.994371 C34.2736052,178.306117 33.0512757,175.714714 36.0045784,173.68967 C43.3623323,168.644547 53.9653015,159.814672 55.3979297,156.908251 C57.3515741,152.944826 61.6549068,131.648706 68.3079281,93.0198914 Z",
  id: "Skin",
  fill: "#D4A181"
}), React.createElement("path", {
  d: "M122.01899,9.23199981 L130.503942,7.00082913 C148.576175,42.7520052 177.414525,74.1501034 217.01899,101.195124 L192.061793,137.56505 C151.33882,97.6857553 124.670571,55.1985909 122.01899,9.23199981 Z",
  id: "Coat-Back",
  fill: "#191847",
  transform: "translate(169.518990, 72.282940) rotate(5.000000) translate(-169.518990, -72.282940) "
}), React.createElement("path", {
  d: "M90,114 L167,114 C149.16087,70.6251468 140.241304,33.7787236 140.241304,3.4607303 L117.014208,0 C98.7598929,29.3584068 93.6048263,65.5045499 90,114 Z",
  id: "Shirt",
  fill: "#DDE3E9"
}), React.createElement("path", {
  d: "M116.522435,0.0164198669 C116.525484,0.0109456263 116.528534,0.00547233727 116.531583,-1.73374996e-14 L118.047752,-4.26343884e-14 C119.86198,0.0624731357 122.625282,0.175030894 126.337658,0.337673275 L131.950158,16.3768801 C132.543836,35.9324229 136.010826,75.3421183 142.351127,134.605966 L91.8760816,134.605966 C92.0084015,138.699076 92.2265759,142.83042 92.5306047,147 L55,147 C60.6139164,83.6639633 81.1152373,34.6639633 116.503963,1.42108547e-14 L116.522435,0.0164198605 Z",
  id: "Coat-Front",
  fill: "#2F3676"
}), React.createElement("path", {
  d: "M95.2102301,82.2331012 C96.6467433,107.747892 100.243333,125.336858 106,135 L91.889081,135 C91.27131,116.642855 92.3783599,99.0539088 95.2102289,82.2331082 Z",
  id: "Shade",
  fillOpacity: 0.1,
  fill: "#000000"
}), React.createElement("polygon", {
  id: "Light",
  fillOpacity: 0.2,
  fill: "#FFFFFF",
  points: "103.110899 104 128 92.4292718 128 104"
})))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "474px",
    height: "430px",
    viewBox: "0 0 474 430",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/footer-mynd.8249559e.svg";
export { SvgComponent as ReactComponent };